import * as React from "react";
import {isEmpty as _isEmpty} from "lodash"
import * as moment from "moment";
import IDoctorProfile from "../../models/IDoctorProfile";
import AssetProvider from "../../utils/AssetProvider";

export interface DoctorProfileCardProps {
    doctorProfile: IDoctorProfile
}

const DoctorProfileCard = (props: DoctorProfileCardProps) => {
    let doctorProfile = props.doctorProfile;
    let doctorName = `${!_isEmpty(props.doctorProfile.prefix) ? props.doctorProfile.prefix + " " : ""}${props.doctorProfile.name}`;
    let qualification = doctorProfile.qualification;
    let phoneString = `Mobile: ${!_isEmpty(doctorProfile.phoneNumbers) ? doctorProfile.phoneNumbers[0].phoneNumber : ""}`;
    let emailString = `Email: ${doctorProfile.emailId}`;
    return (
        <div className={"doctor-profile-card"}>
            <div className={"image-container"}><img src={AssetProvider.getDoctorImage(props.doctorProfile)} /></div>
            <div className={"info-container"}>
                <div className={"doctor-name brandon-bold"}>{doctorName}</div>
                <div className={"doctor-specialities"}>{qualification}</div>
                <div className={"doctor-information"}>
                    <div className={"doctor-information-block"}>
                        <div className={"info-header-label brandon-bold"}>REGN. NO</div>
                        <div className={"info-header-value"}>{doctorProfile.registrationNumber}</div>
                    </div>
                    <div className={"doctor-information-block"}>
                        <div className={"info-header-label brandon-bold"}>EXPERIENCE</div>
                        <div className={"info-header-value"}>{doctorProfile.experience}</div>
                    </div>
                </div>
            </div>
            <div className={"contact-info brandon-bold"}>
                <div className={"mobile-number"}>{phoneString}</div>
                <div className={"email-info"}>{emailString}</div>
            </div>
        </div>
    )
}

export default DoctorProfileCard;